import * as css from 'css/exports.module.scss';
import './EmailAlertRecipientsList.scss';
import { EmailAlertRecipientField } from './EmailAlertRecipientField';
import React from 'react';
import { Space } from 'antd';
export const EmailAlertRecipientsList = ({ parentIndex, recipients }) => React.createElement(Space, { className: 'email-alert-recipients', direction: 'vertical', size: Number(css.size4) }, recipients.map((record) => React.createElement(EmailAlertRecipientField, { key: record.recipient, parentIndex: parentIndex, record: record })));
